import React from 'react'

function OurExpertise() {
  return (
    <div>
      <div className='mx-auto p-6 text-center'>
      <section className="w-full bg-white text-white rounded-lg">
      <div>
        <div className="gap-6 items-center">
          
          <div className="bg-white text-[#0C2340] p-6 rounded-lg">
            <h2 className="text-2xl md:text-3xl font-bold mb-2">
            LATEST INDUSTRY NEWS & INNOVATIONS
            </h2>
            <p className="text-sm md:text-lg">Expert Solutions to Support Your Success, Every Step of the Way</p>
            <div>
        </div>

          </div>
         
        </div>
     
      </div>
    </section>
    </div>
    </div>
  )
}

export default OurExpertise
